export enum DrawStatus {
    InProgress = 1,
    Request = 2,
    Inspecting = 3,
    NeedToFund = 4,
    Finalized = 5,
    NotFinalized = 6,
}

const drawStatusDescription: string[] = [];
drawStatusDescription[DrawStatus.InProgress] = 'In Progress';
drawStatusDescription[DrawStatus.Request] = 'Request';
drawStatusDescription[DrawStatus.Inspecting] = 'Inspecting';
drawStatusDescription[DrawStatus.NeedToFund] = 'Need to Fund';
drawStatusDescription[DrawStatus.Finalized] = 'Finalized';
drawStatusDescription[DrawStatus.NotFinalized] = 'Not Finalized';

export { drawStatusDescription };
